import type { StepConfig } from "@portal/components/multiform/types";
import { BondStep } from "../../../../../agent/account/create/steps/bond/BondStep";
import type { AdminCombinedFormData } from "../../schema";
import { BondSummary } from "./BondSummary";

export const bondStepConfig: StepConfig<AdminCombinedFormData> = {
	name: "bond",
	label: "Bond",
	fieldPaths: ["quote", "bondType", "contractBondType", "commercialBond"],
	component: BondStep,
	summaryComponent: BondSummary,
};
